import { Alert, AlertDescription, AlertIcon, Box, Button, Divider, FormControl, FormHelperText, FormLabel, Icon, Img, Input, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useBoolean, useDisclosure, useToast, UseToastOptions } from "@chakra-ui/react";
import { ISignInApi, ISignInInfo, ISignInWithFacebookApi, IUserPub, IUserPubOwn, IUserSignedIn, TUserSummary } from "@api/auth.int";
import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { useVVApi } from "components/api";
import { useLocation, useNavigate } from "react-router";
import { VizvButtonCancel, VizvButtonPrimary, VizvCardHeader } from "components/vizvComponents";
import { DeepErrorBox } from "components/misc";
import { RemoteButton } from "components/RemoteButton";
import { SignUp } from "./SignUp";
import { useVVStore } from "components/store";
import { IProfileGetApi } from "@api/profile.int";
import { GoogleLogin } from '@react-oauth/google';
import { UserForgottenPass } from "./UserForgottenPass1";
import { MdPerson, MdPersonAdd } from "react-icons/md";

export type TProtectionLevel = 'confirmed' | 'anyuser' | 'any'; //|'admin';
export type TProtectionResult = false | 'not_confirmed' | 'not_logged_in';

export type TSignStage = 'signin' | 'signup' | 'forgotten-pass';

export interface IDeepAuthContext {
	signedUser?: IUserSignedIn,
	signature?: string;
	userConfirmed?: IUserPubOwn;
	userAny?: IUserPubOwn;
	userAdmin?: IUserPubOwn;
	showSignIn: (msg?: string) => void,
	signOut: () => void,
	signInWithInfo: (info: ISignInInfo) => void,
	protectionFailed: (protLev: TProtectionLevel) => TProtectionResult,
	getToken: () => string;

}

const createDefaultContext = () => {
	const ctx : IDeepAuthContext = {
		showSignIn: () => { throw `no auth ctx` },
		signOut: () => { throw `no auth ctx` },
		signInWithInfo: () => { throw `no auth ctx` },
		protectionFailed: () => { throw `no auth ctx` },
		getToken: () => { throw `no auth ctx` },
	}
	ctx.getToken = () => btoa(JSON.stringify({ signedUser: ctx.signedUser, signature: ctx.signature, }));
	return ctx;
}

export const DeepAuthContext = createContext<IDeepAuthContext>(createDefaultContext());

export interface DeepAuthProps {
	children: React.ReactNode;
}

export function DeepAuth({ children }: DeepAuthProps) {

	const api = useVVApi();
	const nav = useNavigate();

	const setMyProfile = useVVStore(stage => stage.setMyProfile);
	const myProfile = useVVStore(stage => stage.myProfile);

	const toast = useToast();

	const refreshLogin = async () => {
		const infoStr = window.localStorage.getItem('signin-info');
		console.log('... check login');
		if (infoStr) {
			try {
				const info = JSON.parse(infoStr);
				startSignedUser = info.signedUser;
				startSignature = info.signature;
				setSignedUser(info.signedUser);
				setSignature(info.signature);
				const resp = await api.fetch<IProfileGetApi>({
					url: '/auth/profile/:userKey', method: 'GET',
					params: { userKey: info.signedUser.userKey }
				});
				setMyProfile(resp.user);
			} catch (ex) {
				toast({
					title: 'Hibás bejelentkezési adatok.',
					description: '' + ex,
					status: 'error',
				});
			}
		}

	}

	let startSignedUser: IUserSignedIn | undefined;
	let startSignature = '';
	let startError: UseToastOptions | undefined;
	const infoStr = window.localStorage.getItem('signin-info');
	if (infoStr) {
		try {
			const info = JSON.parse(infoStr);
			startSignedUser = info.signedUser;
			startSignature = info.signature;
		} catch (ex) {

			startError = {
				title: 'Hibás bejelentkezési adatok.',
				description: '' + ex,
				status: 'error',
			};
		}
	}

	const [signedUser, setSignedUser] = useState<IUserSignedIn | undefined>(startSignedUser);
	const [signature, setSignature] = useState<string | undefined>(startSignature);
	useEffect(() => {
		if (startError)
			toast(startError);
	}, [startError])

	const signInWithInfo = useCallback((info: ISignInInfo) => {
		setSignedUser(info.signedUser);
		setSignature(info.signature);
		setMyProfile(info.myUser);
		window.localStorage.setItem('signin-info', JSON.stringify(info));
	}, []);
	const signOut = useCallback(() => {
		//e.preventDefault();

		setSignedUser(undefined);
		setSignature(undefined);
		setMyProfile(undefined);
		window.localStorage.removeItem('signin-info');
		nav('/map');
	}, []);


	// ==============================================================================================================================


	const [stage, setStage] = useState<TSignStage>('signin');
	const [message, setMessage] = useState('');
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [isLoading, setIsLoading] = useBoolean();
	const [error, setError] = useState('');

	const loc = useLocation();
	const isAckEmail = loc.pathname === '/ack/email-confirmed';
	useEffect(() => {
		if (isAckEmail) {
			onOpen();
			if (signedUser)
				signOut();

		}
	}, [isAckEmail, signedUser]);


	const showSignIn = (msg?: string) => {
		setMessage(msg || '');
		onOpen();
		setError('');
		setStage('signin');
	}

	const usrSubmitSignIn = async (e: React.SyntheticEvent) => {
		console.log('ittt');
		e.preventDefault();
		const target = e.target as typeof e.target & {
			email: { value: string };
			password: { value: string };
		};
		const email = target.email.value;
		const password = target.password.value;
		setIsLoading.on();
		setError('');
		try {
			const grecaptchaToken = await getGReCaptcha();
			console.log(grecaptchaToken);
			const resp = await api.fetch<ISignInApi>({
				url: '/auth/signin',
				method: 'POST',
				payload: {
					email, password, grecaptchaToken,
				}
			});
			signInWithInfo(resp);
			onClose();
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}
	}



	//const [FBData, setFBData] = useState

	const [FBError, setFBError] = useState('');
	const fbLogout = () => {
		FB.logout(response => {
			console.log('LOGOUT', response);
		});
	}
	const fbLogin = () => {
		setFBError('');
		setIsLoading.on();
		FB.getLoginStatus(function (response) {
			setIsLoading.off();
			//statusChangeCallback(response);
			console.log('FB LOGIN STATUS');
			console.log(response);
			if (response.status === 'connected' && response.authResponse && response.authResponse.signedRequest && response.authResponse.userID) {
				fbGetUser(response.authResponse);
			} else {
				FB.login(function (response) {
					if (response.status === 'connected' && response.authResponse && response.authResponse.signedRequest && response.authResponse.userID) {
						//store.setFBStatus(response);
						fbGetUser(response.authResponse);
					} else {
						//If you are not logged in, the login dialog will open for you to login asking for permission to get your public profile and email -->
						setFBError('User cancelled login or did not fully authorize.');
					}
				});

			}
		});

	}


	const fbGetUser = (fbAuth: fb.AuthResponse) => {
		setIsLoading.on();
		FB.api('/me', { fields: 'name, email, picture.type(small)' }, function (response: any) {
			setIsLoading.off();
			console.log('FB /me');
			console.log(response);
			if (response && response.error && response.error.message) {
				setFBError(response.error.message)
				return;
			}
			fbLogin2({
				userID: fbAuth.userID,
				email: response.email,
				name: response.name,
				picture_url: response.picture.data.url,
				signedRequest: fbAuth.signedRequest!
			})

		});
	}

	const fbLogin2 = async (data: ISignInWithFacebookApi['request']['payload']) => {
		setIsLoading.on();
		try {
			///debugger;
			const resp = await api.fetch<ISignInWithFacebookApi>({
				url: '/auth/signin_with_facebook',
				method: 'POST',
				payload: data
			});
			signInWithInfo(resp);
			onClose();
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}

	}


	// ==============================================================================================================================

	const signUpReady = (msg: string) => {
		setError('');
		setStage('signin');
		setMessage(msg);
	}

	const protectionFailed = useCallback((protLev: TProtectionLevel): TProtectionResult => {
		if (protLev !== 'any' && (!signedUser))
			return 'not_logged_in'
		if (protLev === 'confirmed' && (!signedUser || signedUser.status !== 'C'))
			return 'not_confirmed';
		return false;
	}, [signedUser]);


	const ctx = useMemo<IDeepAuthContext>(() => {
		return {
			userConfirmed: signedUser && signedUser.status === 'C' ? myProfile : undefined,
			userAny: myProfile,
			userAdmin: myProfile?.isAdmin ? myProfile : undefined,
			signedUser,
			signature,
			showSignIn,
			signOut,
			signInWithInfo,
			protectionFailed,
			getToken: () => btoa(JSON.stringify({ signedUser: signedUser, signature: signature, }))
		}
	}, [signOut, showSignIn, signedUser, signature, myProfile, signInWithInfo, protectionFailed]);

	return <DeepAuthContext.Provider value={ctx} >
		{children}

		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />



			{stage === 'signin' && <>
				<form onSubmit={usrSubmitSignIn}>
					<ModalContent bg='cardbg.popup' >
						<ModalHeader >
							<ModalCloseButton />
							<VizvCardHeader fontSize='xl' boxShadow='lg' mt={1} isModal>Belépés</VizvCardHeader>
						</ModalHeader>
						<ModalBody>
							<DeepErrorBox error={error} />
							<DeepErrorBox error={FBError} />
							{message && <Alert status="success">
								<AlertDescription><AlertIcon />{message}</AlertDescription>
							</Alert>}

							{isAckEmail && <Alert status='success' mb={3}>
								<AlertIcon />
								<AlertDescription>
									Megerősítetted az email-címed. Kérlek lépj be!
								</AlertDescription>
							</Alert>}
							{!signedUser && <>
								<fieldset disabled={isLoading}>
									<FormControl>
										<FormLabel>Email cím</FormLabel>
										<Input type='email' autoComplete="username" name='email' />
										<FormHelperText>&nbsp;</FormHelperText>
									</FormControl>
									<FormControl>
										<FormLabel>Jelszó</FormLabel>
										<Input type='password' autoComplete="current-password" name='password' />
										<FormHelperText>&nbsp;</FormHelperText>
									</FormControl>
								</fieldset>
								<Box my={3} display='flex' flexDir='row' justifyContent='center'>
									<Button variant='link' onClick={() => setStage('forgotten-pass')} colorScheme='primary' >Elfelejtettem a jelszavam</Button>
								</Box>
							</>}
							{signedUser && signedUser.status !== 'C' && <><Alert status='warning'>
								<AlertIcon />
								<AlertDescription>
									Az email címedet nem erősítetted még meg, kérlek tedd meg!
								</AlertDescription>
							</Alert>
								<Box my={3} display='flex' flexDir='row' justifyContent='center'>
									<Button variant='link' onClick={() => setStage('forgotten-pass')} colorScheme='primary' >Regisztrációs email újraküldése</Button>
								</Box>

							</>}

							<GReCaptchaBox />

							{!signedUser && <>
								<Box display='flex' flexDir='column' gap='2' my={3}>
									<Box display='flex' flexDir='row' justifyContent='space-between' alignItems='center'>
										<VizvButtonCancel onClick={() => setStage('signup')} leftIcon={<MdPersonAdd />}>Regisztráció</VizvButtonCancel>
										<VizvButtonPrimary type='submit' isLoading={isLoading} ml={3} leftIcon={<MdPerson />} protLev='any' >
											Belépés
										</VizvButtonPrimary>
									</Box>


									{/*	
								<Divider />
								<Box display='flex' flexDir='row' justifyContent='space-between' alignItems='center'>

								<GoogleLogin useOneTap
										onSuccess={(credentialResponse) => {
											console.log(credentialResponse);
										}}
										onError={() => {
											console.log('Login Failed');
										}}
									/>
								</Box>
								<RemoteButton onClick={fbLogin} colorScheme='secondary' isLoading={isLoading} ml={2}>Belépés facebook-kal...</RemoteButton>*/}
								</Box>
							</>}
						</ModalBody>
					</ModalContent>
				</form>
			</>}

			{stage === 'signup' && <SignUp onSignIn={signUpReady} />}
			{stage === 'forgotten-pass' && <UserForgottenPass onSignIn={signUpReady} />}
		</Modal>
	</DeepAuthContext.Provider>
}

export function GReCaptchaBox() {
	return <Box color='InactiveCaptionText' fontSize='sm' my={2}>
		This site is protected by reCAPTCHA and the Google
		<a href="https://policies.google.com/privacy">Privacy Policy</a> and
		<a href="https://policies.google.com/terms">Terms of Service</a> apply.
	</Box>
}

export function getGReCaptcha(): Promise<string> {
	return new Promise((resolve, reject) => {
		const recaptcha = (window as any).grecaptcha;
		recaptcha.ready(function () {
			console.log('ReCatpcha ready');
			recaptcha.execute('6Ld7BPYqAAAAAP3B63X4joFX02pgZUPtlnRA-uNZ', { action: 'submit' }).then(async function (grecaptchaToken) {
				resolve(grecaptchaToken);
			}).catch((ex) => {
				reject(ex);
			});
		});
	});
}